import * as $ from 'jquery'
import { Component, OnInit, Input } from '@angular/core'

@Component({
  selector: 'app-aldagi-header',
  templateUrl: './aldagi-header.component.html',
  styleUrls: ['./aldagi-header.component.scss']
})
export class AldagiHeaderComponent implements OnInit {
  @Input() baseUrl: string
  agent = {
    message: ''
  }
  constructor() {}

  ngOnInit() {
    jQuery(function() {
      const uberMenuScrollBreakpoint = 1199
      function t() {
        $('body').hasClass('uber-is-open')
          ? ($('.header-uber').removeClass('open'),
            $('.header-uber-toggle').addClass('collapsed'),
            $('body').removeClass('uber-is-open'),
            $('.header-search').removeClass('open'),
            $('body').removeClass('search-is-open'))
          : ($('.header-uber').addClass('open'), $('.header-uber-toggle').removeClass('collapsed'), $('body').addClass('uber-is-open'))
      }
      $('body').on('click', '.header-uber-toggle', function(e) {
        return t(), e.preventDefault(), !1
      })

      $('body').on('click', '.header-search-toggle,.header-uber .header-search-title', function(e) {
        return (
          $('body').hasClass('uber-is-open')
            ? $('.header-uber .header-search').addClass('open')
            : $('.header-main-col>.header-search').addClass('open'),
          $('body').addClass('search-is-open'),
          e.preventDefault(),
          !1
        )
      }),
        $('body').on('click', '.header-search-close', function(e) {
          return $('.header-search').removeClass('open'), $('body').removeClass('search-is-open'), e.preventDefault(), !1
        })
    })
  }
}
